import { BoxProps } from '@amzn/awsui-components-react';

export interface Resource {
    currency: string;
    mainframeName: string;
    environmentType: string;
    isDisasterRecovery: string;
    resourceName: string;
    resourceType: string;
    unit: string;
    count: number;
    monthlyCost?: number;
    unitMonthlyCost?: number;
}

export interface SizeAssessment {
    mainframeName: string;
    mainframeEnvMatches: any[];
    timestamp: string;
}

export interface DetailsTabProps {
    currency: string;
    resources: SizeAssessment[];
}

export interface SummaryTabProps {
    currency: string;
    migrationCosts: MainframeMigrationCosts;
    onPremCosts: MainframeOnPremCosts;
    awsCosts: MainframeAWSCosts;
}

export enum SummaryRowNumberDisplayOptions {
    PERCENTAGE = 'percentage',
}

export interface SummaryRowFormat {
    align?: BoxProps.TextAlign;
    numberDisplay?: SummaryRowNumberDisplayOptions;
    textStyle?: BoxProps.Variant;
}

export interface SummaryRow {
    currency?: string;
    description: string;
    value: string | number;
    format?: SummaryRowFormat;
}

export interface CashflowTabProps {
    currency: string;
    cashflow: MainframeCashflow;
}

export interface CashflowTables {
    costs: CashflowRow[];
    totalCosts: CashflowRow[];
    cummulativeCosts: CashflowRow[];
}

export interface CashflowRow {
    currency?: string;
    description: string;
    cashflowValues: number[];
    format?: SummaryRowFormat;
}

export interface MainframeCashflow {
    duration: number;
    aws: number[];
    onPrem: number[];
    migration: number[];
    cumulativeMigrateToAWS: number[];
    cumulativeStayOnPrem: number[];
    cumulativeSavings: number[];
    cumulativeDifference: number[];
    totalMigrateToAWS: number[];
    totalStayOnPrem: number[];
    totalSavings: number[];
    totalDifference: number[];
}

export interface MainframeOnPremCosts {
    connectivityCost: number;
    disasterRecoveryCost: number;
    hardwareCost: number;
    occupancyCost: number;
    personnelCost: number;
    softwareCost: number;
    totalCost: number;
    totalInstalledMIPS: number;
    unallocatedCost: number;
    annualCosts: number[];
}

export interface MainframeMigrationCosts {
    numberOfLinesOfCode: number;
    numberOfTestCases: number;
    numberOfIntegratedDependencies: number;
    projectDurationInYears: number;
    laborCost: number;
    toolCost: number;
    otherCosts: number;
    totalCost: number;
    annualCosts: number[];
}

export interface MainframeAWSCosts {
    laborCost: number;
    supportCost: number;
    totalCost: number;
    annualCosts: number[];
    infrastructureCost: number;
    mainframe3rdPartyCost: number;
    totalInstanceCount: number;
    totalStorageTBSize: number;
    otherCosts: number;
    disasterRecoveryType: string;
    disasterRecoveryCost: number;
}
